
<template>
  <div>
    <va-modal
      class="modal"
      v-model="showModal"
      max-width="100%"
      :okText="infosStatutsUpdated?'Sauvegarder':'Fermer'"
      cancelText="Annuler"
      v-on:cancel="closeModal"
      v-on:ok="saveInfos"
      noEscDismiss
      :noOutsideDismiss="infosStatutsUpdated"
    >
      <div class="row row-inside customsizerfc">
        <div class="flex md12">
          <h5
            class="custom-label-task"
            :style="{ color: this.$themes.primary  }"
          >Souhaitez vous retirer {{nomEntreprise}} de la campagne d'adhésion</h5>
        </div>

        <div class="row row-inside">
          <div class="flex md12 allsyndicat">
            <va-toggle small v-model="infos.allSyndicat" label="Tous syndicat" />
          </div>
          <div class="flex md6 limitmargin" v-show="!infos.allSyndicat">
            <div class="row row-inside">
              <div class="flex md12 px-2 mb-1">
                <va-checkbox label="UNPF" v-model="infos.isUnpf" />
              </div>
              <div class="flex md12">
                <va-toggle
                  :disable="!infos.isUnpf"
                  small
                  v-model="infos.unpfUndefinite"
                  label="Définitivement"
                />
              </div>
              <div class="flex md12 px-2">
                <va-date-picker
                  :disabled="infos.unpfUndefinite"
                  :config="{ dateFormat: 'd-m-Y' }"
                  label="Date de réintégration"
                  v-model="infos.unpf"
                />
              </div>
            </div>
          </div>
          <div class="flex md6 limitmargin" v-show="!infos.allSyndicat">
            <div class="row row-inside">
              <div class="flex md12 px-2 mb-1">
                <va-checkbox label="SPEF" v-model="infos.isSpef" />
              </div>
              <div class="flex md12">
                <va-toggle
                  :disable="!infos.isSpef"
                  small
                  v-model="infos.spefUndefinite"
                  label="Définitivement"
                />
              </div>
              <div class="flex md12 px-2">
                <va-date-picker
                  :disabled="infos.spefUndefinite"
                  :config="{ dateFormat: 'd-m-Y' }"
                  label="Date de réintégration"
                  v-model="infos.spef"
                />
              </div>
            </div>
          </div>
          <div class="flex md6 limitmargin" v-show="infos.allSyndicat">
            <div class="row row-inside">
              <div class="flex md12">
                <va-toggle small v-model="infos.allUndefinite" label="Définitivement" />
              </div>
              <div class="flex md12 px-2 mb-5">
                <va-date-picker
                  :disabled="infos.allUndefinite"
                  :config="{ dateFormat: 'd-m-Y' }"
                  label="Date de réintégration"
                  v-model="infos.alldate"
                />
              </div>
            </div>
          </div>
          <div class="flex md12">
            <va-input
              v-model="infos.comment"
              label="Commentaire:"
              type="textarea"
              autosize
              :minRows="4"
              :maxRows="4"
            />
          </div>
        </div>
      </div>
    </va-modal>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import { cloneDeep, isEqual } from "lodash";

export default {
  name: "RemoveFromCampaign",
  props: ["value", "identreprise", "nomEntreprise"],
  data() {
    return {
      infosStatutsUpdated: false,
      infos: {
        alldate: null,
        unpfUndefinite: false,
        spefUndefinite: false,
        allUndefinite: false,
        allSyndicat: false,
        isSpef: false,
        isUnpf: false,
        identreprise: null,
        spef: null,
        unpf: null,
        comment: null
      },
      infosRef: {
        alldate: null,
        unpfUndefinite: false,
        spefUndefinite: false,
        allUndefinite: false,
        allSyndicat: false,
        isSpef: false,
        isUnpf: false,
        identreprise: null,
        spef: null,
        unpf: null,
        comment: null
      },
      showModal: false
    };
  },
  computed: {
    dateSpefDisable() {
      return this.infos.spefUndefinite || !this.infos.isSpef;
    }
  },
  methods: {
    async saveInfos() {
      this.showModal = true;

      // check if apply to all or one specific
      if (this.infos.allSyndicat) {
        this.infos.isSpef = true;
        this.infos.isUnpf = true;
        if (this.infos.allUndefinite) {
          this.infos.spefUndefinite = true;
          this.infos.unpfUndefinite = true;
        } else {
          this.infos.spef = this.infos.alldate;
          this.infos.unpf = this.infos.alldate;
        }
      }

      // convert the date in Mysql format
      if (this.infos.spefUndefinite) {
        this.infos.spef = "31-12-9999";
      }
      if (this.infos.unpfUndefinite) {
        this.infos.unpf = "31-12-9999";
      }
      let spef = this.infos.spef
        ? moment(this.infos.spef, "DD-MM-YYYY").format("YYYY-MM-DD")
        : null;
      let unpf = this.infos.unpf
        ? moment(this.infos.unpf, "DD-MM-YYYY").format("YYYY-MM-DD")
        : null;

      if (!this.infos.isSpef) {
        spef = null;
      }
      if (!this.infos.isUnpf) {
        unpf = null;
      }

      let params = {
        identreprise: this.identreprise,
        spef: spef,
        unpf: unpf,
        comment: this.infos.comment
      };

      try {
        await axios.put("/api/campagne/norelance", params);

        this.infos.spef = spef;
        this.infos.unpf = unpf;

        this.closeModal(true);
      } catch (err) {
        //TODO
      }
    },
    closeModal(done) {
      if (done) {
        let spef = false;
        let unpf = false;
        console.log("test2", this.infos.spef, this.infos.unpf);
        if (
          this.infos.spef &&
          !moment(this.infos.spef, "YYYY-MM-DD").isBefore(moment())
        ) {
          spef = true;
        }
        if (
          this.infos.unpf &&
          !moment(this.infos.unpf, "YYYY-MM-DD").isBefore(moment())
        ) {
          unpf = true;
        }

        this.$emit("reset", {
          identreprise: this.identreprise,
          spef: spef,
          unpf: unpf
        });
      }
      this.resetComponent();
      this.$emit("input", false);
    },
    resetComponent() {
      this.infos = {
        unpfUndefinite: false,
        spefUndefinite: false,
        allUndefinite: false,
        allSyndicat: false,
        isSpef: false,
        isUnpf: false,
        identreprise: null,
        spef: null,
        unpf: null,
        comment: null
      };
      this.infosRef = {
        unpfUndefinite: false,
        spefUndefinite: false,
        allUndefinite: false,
        allSyndicat: false,
        isSpef: false,
        isUnpf: false,
        identreprise: null,
        spef: null,
        unpf: null,
        comment: null
      };
    },
    async loadStatus() {
      try {
        let response = await axios.get("/api/campagne/norelance-entreprise", {
          params: { identreprise: this.identreprise }
        });
        let infos = response.data;

        if (moment(infos.spef, "YYYY-MM-DD").isBefore(moment())) {
          infos.spef = null;
        }

        if (moment(infos.unpf, "YYYY-MM-DD").isBefore(moment())) {
          infos.unpf = null;
        }

        if (infos.spef && infos.spef === infos.unpf) {
          // check if set to the same infos
          this.infos.allSyndicat = true;
          this.infos.alldate = moment(infos.spef, "YYYY-MM-DD").format(
            "DD-MM-YYYY"
          );
          if (this.infos.alldate === "31-12-9999") {
            this.infos.allUndefinite = true;
            this.infos.alldate = null;
          }
        }

        this.infos.spef = infos.spef
          ? moment(infos.spef, "YYYY-MM-DD").format("DD-MM-YYYY")
          : null;
        this.infos.unpf = infos.unpf
          ? moment(infos.unpf, "YYYY-MM-DD").format("DD-MM-YYYY")
          : null;

        if (infos.spef) {
          this.infos.isSpef = true;
        }

        if (infos.unpf) {
          this.infos.isUnpf = true;
        }

        if (this.infos.spef === "31-12-9999") {
          this.infos.spefUndefinite = true;
          this.infos.spef = null;
        }
        if (this.infos.unpf === "31-12-9999") {
          this.infos.unpfUndefinite = true;
          this.infos.unpf = null;
        }

        this.infos.comment = infos.comment;

        this.infosRef = cloneDeep(this.infos);
      } catch (err) {}
    }
  },
  watch: {
    infos: {
      deep: true,
      handler() {
        if (!isEqual(this.infos, this.infosRef)) {
          this.infosStatutsUpdated = true;
        } else {
          this.infosStatutsUpdated = false;
        }
      }
    },
    value() {
      this.showModal = this.value;
      // Parent property changed; update internal variables
      if (!this.value) {
        this.resetComponent();
      } else if (!this.identreprise) {
        // TODO error no identreprise
        console.log("no identreprise");
      } else {
        this.loadStatus();
      }
    }
  }
};
</script>

<style scoped>
.customsizerfc {
  position: relative;
  width: 30vw;
  height: 40vh;
}
.allsyndicat {
  position: absolute;
  top: 2.5em;
}
.limitmargin {
  margin-top: 3.5em;
}
</style>
